export enum EmergencyAlarmLocationType {
  None = 'None',
  Gps = 'Gps',
  Internal = 'Internal',
  GpsAndInternal = 'GpsAndInternal',
}
